var _path, _defs, _mask, _path2, _defs2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "currentColor",
    height: "1em",
    width: "1em",
    viewBox: "0 0 42 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.7,42h8.7V14H0.7V42z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10.1,
    height: 10.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 10.1,
    height: 10.2,
    id: "b_00000179636330128309848410000013077446989297352357_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "a_00000111907072726365411710000009638988946451559815_",
    d: "M0,0.1h10.1v10.1H0V0.1z"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5,10.2c2.8,0,5-2.3,5-5c0-2.8-2.2-5.1-5-5.1S0,2.2,0,5c0,0,0,0.1,0,0.1C0,7.9,2.3,10.2,5,10.2 C5,10.2,5,10.2,5,10.2"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000139983177377187327230000017377958748687058839_",
    filterUnits: "userSpaceOnUse",
    x: 14.9,
    y: 13.3,
    width: 27.1,
    height: 28.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 14.9,
    y: 13.3,
    width: 27.1,
    height: 28.7,
    id: "d_00000134944285030906120590000003806602751964626623_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000139983177377187327230000017377958748687058839_)"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "c_00000155835960735543638390000017399701564244439472_",
    d: "M14.9,13.3H42V42H14.9V13.3z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42,26.6c0-7.5-1.6-13.3-10.4-13.3c-4.2,0-7.1,2.3-8.2,4.5h-0.1V14h-8.3v28h8.7V28.1c0-3.7,0.7-7.2,5.2-7.2 c4.5,0,4.5,4.2,4.5,7.4V42H42V26.6z"
  })));
};
export default SvgLinkedIn;